import { useCallback, useEffect, useMemo, useState } from 'react';
import type { ProjectFileTypeValue } from './projectFileTypeConstants';
import {
  loadProjectFilesTypeFilterFromStorage,
  saveProjectFilesTypeFilterToStorage,
  createDefaultProjectFilesTypeFilterState,
  type ProjectFilesPopoverTypeFilterState,
  type ProjectFilesTypeFilterPersistence,
  isProjectFilesTypeFilterActive,
} from './projectFilesPopoverTypeFilterModel';

export type { ProjectFilesTypeFilterPersistence } from './projectFilesPopoverTypeFilterModel';

export function useProjectFilesPopoverTypeFilter(persistence: ProjectFilesTypeFilterPersistence = 'localStorage') {
  const [state, setState] = useState<ProjectFilesPopoverTypeFilterState>(() =>
    persistence === 'sessionOnly'
      ? createDefaultProjectFilesTypeFilterState()
      : loadProjectFilesTypeFilterFromStorage()
  );

  useEffect(() => {
    if (persistence === 'sessionOnly') return;
    saveProjectFilesTypeFilterToStorage(state);
  }, [state, persistence]);

  const setTypeToggle = useCallback((type: ProjectFileTypeValue, value: boolean) => {
    setState((s) => ({
      ...s,
      types: { ...s.types, [type]: value },
    }));
  }, []);

  const setUntypedToggle = useCallback((value: boolean) => {
    setState((s) => ({ ...s, untyped: value }));
  }, []);

  const isActive = useMemo(() => isProjectFilesTypeFilterActive(state), [state]);

  return { state, setTypeToggle, setUntypedToggle, isActive };
}
